"use client"

import styled from "@emotion/styled"
import Container from "@eurodrive/ui/Container"
import { extractProperty } from "@eurodrive/utils"
import { getUmbracoMediaUrl } from "@eurodrive/utils/getUmbracoMediaUrl"
import { Typography } from "@mui/material"
import Image from "next/image"

const StyledContainer = styled.div`
  padding: 56px 0;
  ${({ theme }) => theme.breakpoints.up("sm")} {
    padding: 64px 0;
  }
`

const StyledGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 48px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 518px;
    gap: 103px;
  }
`

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
`

const ImageContainer = styled.div`
  width: 100%;
  height: 348px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  ${({ theme }) => theme.breakpoints.up("md")} {
    height: 518px;
  }
`

export default function Intro({ textToRight }: { textToRight: any }) {
  const title = extractProperty(textToRight, "title")
  const text = extractProperty(textToRight, "text")
  const image = extractProperty(textToRight, "image")
  return (
    <StyledContainer>
      <Container paddingMobile>
        <StyledGrid>
          <TextBox>
            <Typography variant="h2">{title}</Typography>
            <Typography variant="body2">{text}</Typography>
          </TextBox>
          <ImageContainer>
            <Image
              src={getUmbracoMediaUrl(image)}
              alt=""
              fill
              sizes="(min-width: 900px) 50vw, 100vw"
              style={{ objectFit: "cover" }}
            />
          </ImageContainer>
        </StyledGrid>
      </Container>
    </StyledContainer>
  )
}
